<template>
	<div class="tools-main-wrap">
		<!-- 历史会话栏（参考 app/chat 的轮次/历史会话管理） -->
		<div class="lunci-panel">
			<div class="panel-header">
				<span class="panel-title">聊天历史</span>
				<el-button type="primary" size="mini" icon="el-icon-plus" circle @click="createNewChat"></el-button>
			</div>
			<div class="lunci-list" v-loading="sessionLoading">
				<div v-for="item in chatList" :key="item.guid"
					:class="['lunci-item', { active: chatingId === item.guid }]" @click="selectChat(item)">
					<div class="lunci-row">
						<i v-if="item.isTop" class="el-icon-top top-flag" title="已置顶"></i>
						<span class="lunci-title" :title="item.chatLunciTitle">{{ item.chatLunciTitle }}</span>
					</div>
					<div class="lunci-meta">
						<span class="lunci-time">{{ item.showTime }}</span>
						<span class="lunci-ops" @click.stop>
							<i class="el-icon-edit" title="重命名" @click="renameChat(item)"></i>
							<i :class="item.isTop ? 'el-icon-download' : 'el-icon-top'"
								:title="item.isTop ? '取消置顶' : '置顶'" @click="toggleTop(item)"></i>
							<el-popconfirm title="确定删除该对话吗？" @confirm="removeChatHandler(item)">
								<i slot="reference" class="el-icon-delete" title="删除"></i>
							</el-popconfirm>
						</span>
					</div>
				</div>
				<div v-if="!sessionLoading && chatList.length === 0" class="lunci-empty">暂无对话，点击右上角 + 新建</div>
			</div>
		</div>

		<div class="layout-chat-main">
			<div class="chat-header">
				<span>{{ classDetail.title }}</span>
				<el-select v-model="personalModelGuid" size="mini" clearable placeholder="员工默认模型 / 选择我的个人模型"
					style="width: 280px; margin-left: 16px">
					<el-option v-for="model in personalModels" :key="model.modelGuid" :label="model.displayName"
						:value="model.modelGuid" />
				</el-select>
				<el-button type="text" size="mini" @click="$router.push('/app/personal-models')">管理个人模型</el-button>
			</div>
			<chat-box-v2 ref="chatBox" :_chatDialogs="chatDialogs" :_loading="dialogsLoading"
				:artifact-session-guid="chatingId" :artifact-runtime-engine="artifactRuntimeEngine"
				:artifact-job="artifactJob"></chat-box-v2>
			<div class="chat-input">
				<div class="opt-panel mb4">
					<div class="clean-chat-btn mr4" @click="cleanDialogs">清除聊天记录</div>
					<div v-if="modelSupportImage && !personalModelGuid" class="upload-btn mr4" @click="$refs.imageInput.click()">
						<i class="el-icon-picture-outline"></i> 图片
					</div>
					<div class="upload-btn" @click="$refs.fileInput.click()">
						<i class="el-icon-paperclip"></i> 文件
					</div>
					<input type="file" ref="imageInput" accept="image/jpeg,image/png,image/webp,image/gif" multiple style="display:none" @change="onImageSelect" />
					<input type="file" ref="fileInput" accept=".txt,.md,.csv,.docx,.xlsx,.xls,.pdf,.pptx" multiple style="display:none" @change="onFileSelect" />
				</div>
				<!-- 待发送附件预览 -->
				<div class="attachments" v-if="uploadedImages.length || uploadedFiles.length">
					<div class="attachment-img" v-for="(img, i) in uploadedImages" :key="'img' + i">
						<img :src="img.preview" class="img-thumb" />
						<i v-if="!img.url" class="el-icon-loading up-loading"></i>
						<i class="el-icon-circle-close remove-btn" @click="removeImage(i)"></i>
					</div>
					<div class="attachment-file" v-for="(f, i) in uploadedFiles" :key="'file' + i">
						<i class="el-icon-document file-icon"></i>
						<span class="file-name">{{ f.name }}</span>
						<i class="el-icon-circle-close remove-btn" @click="removeFile(i)"></i>
					</div>
				</div>
				<div class="chat-input-box">
					<div class="input-box">
						<el-input type="textarea" @keyup.enter.native="send" :rows="2" placeholder="请输入内容" v-model="msgText"
							resize="none"></el-input>
					</div>
					<div class="send-icon">
						<img class="icon" @click="send" src="../../../static/icon/send-icon.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ChatBoxV2 from '@/views/app/layout-chat-v2/chat-box-v2.vue';
import { getClassDetailApi, nowLunciApi } from '@/apis/tools';
import { getChatList, createChat, getChatDialogs, removeChat, setLunciTopApi, updateChat, getAiVendorListApi, getAiVendorModelListApi } from '@/apis/chat';
import { uploadImgApi, uploadDocFileApi } from '@/apis/user';
import { getToken } from '@/utils/auth';
import config from '@/apis/config'
import { listPersonalModelsApi } from '@/apis/personal-model'
import { createClientMessageId } from '@/utils/client-message-id.mjs'
import { presetArtifactRuntime, presetArtifactSignal } from '@/utils/preset-artifact-tasks.mjs'

// 数字员工（文案）对话场景：对应 hms_copywriting_category，sceneValue 为员工(内容项) id
// 统一走 chat-v2 的 WebSocket 结构（Node AgentLoop 三步），不再用 SSE sendOpen；消息由服务端持久化
const CHAT_SCENE = 'copywriting';

export default {
	name: 'layout-tools-main',
	components: { ChatBoxV2 },
	created() {
		this.connectWs();
		this.loadPersonalModels();
	},
	beforeDestroy() {
		this.closeWs();
	},
	props: {
		toolId: Number,
	},

	data() {
		return {
			config,
			personalModels: [],
			personalModelGuid: '',
			msgText: '',
			sendReq: {
				content_cate_id: 0,
			},
			chatDialogs: [],
			// 历史轮次相关
			chatList: [],          // 当前数字员工下的历史轮次列表
			chatingId: '',         // 当前选中的轮次 guid
			sessionLoading: false, // 历史列表加载中
			dialogsLoading: false, // 某轮消息加载中
			classDetail: {
				title: '',
			},
			// 是否正在生成（流式中禁止再发）
			isNewGlobalMsg: false,
			// WebSocket 相关
			ws: null,
			wsConnected: false,
			wsReconnectTimer: null,
			streamingIdx: -1,       // 当前流式 AI 气泡在 chatDialogs 的下标
			artifactJob: null,
			_pendingLunci: null,    // 未完成流式会话的轮次 guid（断线续传用）
			_eventsReceived: 0,     // 已接收事件数（断线续传 fromIdx）
			// 上传附件
			uploadedImages: [],
			uploadedFiles: [],
			modelSupportImage: false,
			_allModelsCache: null,
		};
	},

	computed: {
		artifactRuntimeEngine() {
			return presetArtifactRuntime(this.chatList.find(row => row.guid === this.chatingId), 'copywritingEmployee');
		},
	},
	watch: {
		async toolId(id) {
			this.sendReq.content_cate_id = id;
			this.chatDialogs = [];
			this.chatingId = '';
			// 先取员工详情（含 ai_model / title），发送链路依赖它
			try {
				let res = await getClassDetailApi({ cateId: id });
				this.classDetail = res.data;
				// 图片上传门控：异步查该模型是否支持识图
				this.loadModelImageSupport(this.classDetail.ai_model);
			} catch (error) { }
			// 确保该员工下存在一个“当前轮次”（无则自动创建），并加载历史列表
			try {
				let lunci = await nowLunciApi({ chatScene: CHAT_SCENE, sceneValue: id });
				await this.loadChatList();
				this.chatingId = lunci.data;
			} catch (error) { }
		},
		// 切换轮次：加载该轮历史消息（映射为 chat-box-v2 的消息结构）
		async chatingId(id) {
			this.artifactJob = null;
			if (!id) return;
			this.dialogsLoading = true;
			const requestedId = id;
			try {
				const chats = await getChatDialogs({ chatLunciGuid: id });
				// 防并发：返回时若已切到别的轮次，丢弃结果
				if (this.chatingId !== requestedId) return;
				chats.forEach(item => {
					item.finished = true;
					item.isStreaming = false;
					if (!Array.isArray(item.imgUrls)) item.imgUrls = [];
					if (item.chatRole === 'assistant') {
						if (item.contentType === 'img') {
							item.imgUrls = item.imgUrls.length ? item.imgUrls : [item.chatContent];
							item.chatContent = '';
						}
					} else {
						// 用户消息：不管有没有 fileUrls，只要 chatContent 里有后端追加的文件正文（\n\n【文件：…）
						// 就截断，只回显用户输入的文字，文件正文不展示（参考 /app/chat）；有 fileUrls 再挂文件卡片
						if (item.fileUrls && item.fileUrls.length > 0) {
							item.files = item.fileUrls;
						}
						const raw = item.chatContent || '';
						const markerIdx = raw.indexOf('\n\n【文件：');
						if (markerIdx >= 0) {
							const shown = raw.slice(0, markerIdx).trim();
							item.chatContent = shown;
							item.displayContent = shown;
						} else {
							item.displayContent = raw;
						}
					}
				});
				this.chatDialogs = chats;
			} catch (error) {
				this.$message({ message: '加载历史消息失败', type: 'error' });
			} finally {
				if (this.chatingId === requestedId) {
					this.dialogsLoading = false;
				}
			}
		},
	},
	methods: {
		async loadPersonalModels() {
			try {
				const result = await listPersonalModelsApi();
				this.personalModels = result?.code === 0 && Array.isArray(result.data)
					? result.data.filter(model => model.status === 1 && model.verifiedCapabilities?.text === 'verified') : [];
			} catch (error) {
				this.personalModels = [];
			}
		},
		cleanDialogs() {
			this.chatDialogs = [];
		},
		// —— 图片上传门控：查该模型是否支持识图 ——
		async loadModelImageSupport(guid) {
			if (!guid) { this.modelSupportImage = false; return; }
			try {
				if (!this._allModelsCache) {
					const vendorsRes = await getAiVendorListApi();
					const vendors = (vendorsRes && vendorsRes.data) || [];
					const all = [];
					await Promise.all(vendors.map(async v => {
						try {
							const r = await getAiVendorModelListApi({ modelVendorSign: v.sign, modelType: 'text' });
							((r && r.data) || []).forEach(m => all.push(m));
						} catch (e) { }
					}));
					this._allModelsCache = all;
				}
				const m = this._allModelsCache.find(x => x.guid === guid);
				this.modelSupportImage = !!(m && Number(m.isImageRecognition) === 1);
			} catch (e) { this.modelSupportImage = false; }
		},
		// —— 上传：图片（并行 + loading 遮罩，修复串行卡顿）——
		async onImageSelect(e) {
			const files = Array.from(e.target.files || []);
			e.target.value = '';
			if (files.length === 0) return;
			const loading = this.$loading({ text: '图片上传中...', background: 'rgba(0,0,0,0.2)' });
			try {
				await Promise.all(files.map(async file => {
					if (file.size > 5 * 1024 * 1024) { this.$message({ message: file.name + ' 超过 5MB', type: 'warning' }); return; }
					const preview = await new Promise(resolve => {
						const reader = new FileReader();
						reader.onload = ev => resolve(ev.target.result);
						reader.readAsDataURL(file);
					});
					try {
						const res = await uploadImgApi(file);
						const url = (res && res.code === 0 && res.data) ? (res.data.url || res.data) : '';
						if (!url) throw new Error('no url');
						this.uploadedImages.push({ preview, url });
					} catch (err) {
						this.$message({ message: '图片上传失败：' + file.name, type: 'error' });
					}
				}));
			} finally {
				loading.close();
			}
		},
		// —— 上传：文件（并行 + loading 遮罩）——
		async onFileSelect(e) {
			const SUPPORTED = ['txt', 'md', 'csv', 'docx', 'xlsx', 'xls', 'pdf', 'pptx'];
			const files = Array.from(e.target.files || []);
			e.target.value = '';
			if (files.length === 0) return;
			const loading = this.$loading({ text: '文件上传中...', background: 'rgba(0,0,0,0.15)' });
			try {
				await Promise.all(files.map(async file => {
					const ext = (file.name.split('.').pop() || '').toLowerCase();
					if (!SUPPORTED.includes(ext)) { this.$message({ message: '不支持 .' + ext + ' 格式', type: 'warning' }); return; }
					if (file.size > 5 * 1024 * 1024) { this.$message({ message: file.name + ' 超过 5MB', type: 'warning' }); return; }
					try {
						const res = await uploadDocFileApi(file);
						const url = (res && res.code === 0 && res.data) ? (res.data.url || res.data) : '';
						if (!url) throw new Error('no url');
						this.uploadedFiles.push({ name: file.name, url, type: ext });
					} catch (err) {
						this.$message({ message: file.name + ' 上传失败', type: 'error' });
					}
				}));
			} finally {
				loading.close();
			}
		},
		removeImage(i) { this.uploadedImages.splice(i, 1); },
		removeFile(i) { this.uploadedFiles.splice(i, 1); },
		// 加载当前数字员工下的历史轮次列表
		async loadChatList() {
			this.sessionLoading = true;
			try {
				let list = await getChatList({ chatScene: CHAT_SCENE, sceneValue: this.sendReq.content_cate_id });
				this.chatList = Array.isArray(list) ? list : [];
			} catch (error) {
				this.chatList = [];
			} finally {
				this.sessionLoading = false;
			}
		},
		// 新建轮次
		async createNewChat() {
			if (!this.sendReq.content_cate_id) return;
			try {
				let res = await createChat({
					chatScene: CHAT_SCENE,
					sceneValue: this.sendReq.content_cate_id,
					chatLunciTitle: '新对话',
				});
				await this.loadChatList();
				let newGuid = res && res.data ? res.data : '';
				if (newGuid) this.chatingId = newGuid;
			} catch (error) {
				this.$message({ message: '新建对话失败', type: 'error' });
			}
		},
		// 切换轮次
		selectChat(item) {
			if (this.chatingId === item.guid) return;
			this.chatingId = item.guid;
		},
		// 删除轮次
		async removeChatHandler(item) {
			try {
				await removeChat({ chatLunciGuid: item.guid });
				let deletingCurrent = this.chatingId === item.guid;
				await this.loadChatList();
				if (deletingCurrent) {
					if (this.chatList.length > 0) {
						this.chatingId = this.chatList[0].guid;
					} else {
						this.chatingId = '';
						this.chatDialogs = [];
						await this.createNewChat();
					}
				}
				this.$message({ message: '已删除', type: 'success' });
			} catch (error) {
				this.$message({ message: '删除失败', type: 'error' });
			}
		},
		// 置顶 / 取消置顶
		async toggleTop(item) {
			let targetIsTop = item.isTop ? 0 : 1;
			try {
				let res = await setLunciTopApi(item.guid, targetIsTop);
				if (res && res.code === 0) {
					this.$message({ message: targetIsTop ? '已置顶' : '已取消置顶', type: 'success' });
					await this.loadChatList();
				}
			} catch (error) {
				this.$message({ message: '操作失败', type: 'error' });
			}
		},
		// 重命名轮次
		async renameChat(item) {
			let value;
			try {
				let prompt = await this.$prompt('请输入新的对话名称', '重命名', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValue: item.chatLunciTitle,
					inputValidator: (val) => (val && val.trim().length > 0) ? true : '名称不能为空',
				});
				value = prompt.value.trim();
			} catch (e) {
				return; // 用户取消
			}
			if (value === item.chatLunciTitle) return;
			try {
				await updateChat(item.guid, value);
				this.$message({ message: '已重命名', type: 'success' });
				await this.loadChatList();
			} catch (error) {
				this.$message({ message: '重命名失败', type: 'error' });
			}
		},

		// ──────────────────────────────────────────────
		// WebSocket 连接管理（复用 chat-v2 结构，内联到本组件）
		// ──────────────────────────────────────────────
		connectWs() {
			if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
				return;
			}
			this.ws = new WebSocket(config.wsUrl);

			this.ws.onopen = () => {
				this.wsConnected = true;
				if (this.wsReconnectTimer) {
					clearTimeout(this.wsReconnectTimer);
					this.wsReconnectTimer = null;
				}
				// 断线重连：有未完成的流式会话时，请求服务端补发缺失事件
				if (this._pendingLunci) {
					this.ws.send(JSON.stringify({
						type: 'resume_chat',
						chatLunciGuid: this._pendingLunci,
						fromIdx: this._eventsReceived,
						token: getToken(),
					}));
				}
			};

			this.ws.onmessage = (e) => {
				let event;
				try { event = JSON.parse(e.data); } catch { return; }
				this.handleWsEvent(event);
			};

			this.ws.onclose = () => {
				this.wsConnected = false;
				this.wsReconnectTimer = setTimeout(() => this.connectWs(), 3000);
			};

			this.ws.onerror = () => {
				this.wsConnected = false;
			};
		},
		closeWs() {
			if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
			if (this.ws) { this.ws.close(); this.ws = null; }
		},
		// 处理服务端推送事件
		handleWsEvent(event) {
			const d = this.streamingIdx >= 0 ? this.chatDialogs[this.streamingIdx] : null;
			if (this._pendingLunci) this._eventsReceived++;

			switch (event.type) {
				case 'text_chunk':
					if (d) { d.chatContent += event.content; d.isStreaming = true; }
					break;
				case 'reasoning_chunk':
					if (d) { d.reasoning = (d.reasoning || '') + event.content; d.isStreaming = true; }
					break;
				case 'tool_start':
					if (d) { d.toolLabel = event.label || `执行 ${event.toolName}...`; d.isTooling = true; }
					break;
				case 'tool_done':
					if (d) { d.isTooling = false; d.toolLabel = ''; }
					break;
				case 'structured_data':
					if (this._pendingLunci === this.chatingId) {
						const job = presetArtifactSignal(event.data, this.chatingId);
						if (job) this.artifactJob = job;
					}
					if (d) { d.structuredData = event.data; }
					break;
				case 'done':
					if (d) { d.isStreaming = false; d.isTooling = false; d.finished = true; }
					this.streamingIdx = -1;
					this._pendingLunci = null;
					this._eventsReceived = 0;
					this.isNewGlobalMsg = false;
					// 刷新历史列表（更新排序/标题），不打断当前会话
					this.loadChatList();
					break;
				case 'error':
					if (d) { d.isStreaming = false; d.isTooling = false; d.finished = true; d.isError = true; d.chatContent = '❌ ' + event.message; }
					this.streamingIdx = -1;
					this._pendingLunci = null;
					this._eventsReceived = 0;
					this.isNewGlobalMsg = false;
					this.$message({ message: event.message, type: 'error' });
					break;
				case 'resume_not_found':
					// 服务端没有可恢复的 session（已完成或过期），恢复正常发送状态
					this._pendingLunci = null;
					this._eventsReceived = 0;
					this.isNewGlobalMsg = false;
					break;
			}
		},

		// ──────────────────────────────────────────────
		// 发送消息（WebSocket send_message，chatScene=copywriting）
		// ──────────────────────────────────────────────
		async send() {
			const content = (this.msgText || '').trim();
			// fileUrls：COS URL 数组，PHP 负责下载解析
			const fileUrls = this.uploadedFiles.map(f => ({ name: f.name, url: f.url, type: f.type }));

			// 用户没输入文字但有文件时也允许发送
			if (!content && fileUrls.length === 0) {
				this.$message({ message: '请输入问题 ...', type: 'warning' });
				return;
			}
			if (this.isNewGlobalMsg) {
				this.$message({ message: 'AI正在回答中 ...', type: 'warning' });
				return;
			}
			if (!this.sendReq.content_cate_id) {
				this.$message({ message: '请先选择数字员工', type: 'warning' });
				return;
			}
			if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
				this.$message({ message: '连接中，请稍候重试...', type: 'warning' });
				this.connectWs();
				return;
			}

			const imgPreviews = this.uploadedImages.map(img => img.preview);
			const imgs = this.uploadedImages.map(img => img.url);

			// 本地推入：用户气泡 + AI 占位气泡（字段对齐 chat-box-v2）
			this.chatDialogs.push({
				chatRole: 'user',
				chatContent: content,
				displayContent: content,
				imgUrls: imgPreviews,
				files: fileUrls,
				finished: true,
				isStreaming: false,
			});
			this.chatDialogs.push({
				chatRole: 'assistant',
				chatContent: '',
				reasoning: '',
				finished: false,
				isStreaming: true,
				isTooling: false,
				toolLabel: '',
				structuredData: null,
				isError: false,
			});

			this.streamingIdx = this.chatDialogs.length - 1;
			this._pendingLunci = this.chatingId || null;
			this._eventsReceived = 0;
			this.msgText = '';
			this.uploadedImages = [];
			this.uploadedFiles = [];
			this.isNewGlobalMsg = true;

			this.ws.send(JSON.stringify({
				type: 'send_message',
				clientMessageId: createClientMessageId(),
				content,
				imgs,
				fileUrls,
				chatLunciGuid: this.chatingId || '',
				aiModelGuid: this.classDetail.ai_model || '',
				modelRef: this.personalModelGuid ? { source: 'personal', modelGuid: this.personalModelGuid } : null,
				chatScene: CHAT_SCENE,
				sceneValue: String(this.sendReq.content_cate_id),
				lastMsgId: '',
				token: getToken(),
				app_type: 'xiaoyipc',
				app_guid: this.$store.state.merchantGuid || '',
				enableThinking: false,
				temperature: null,
				topP: null,
				maxOutputTokens: this.classDetail.maxOutputTokens || 2048,
				systemPrompt: '',
				isMultiple: 1,
			}));
		},
	},
};
</script>

<style lang="scss" scoped>
.tools-main-wrap {
	width: 100%;
	height: 100%;
	display: flex;
	flex: 1;
	min-width: 0;
}

.lunci-panel {
	width: 230px;
	flex-shrink: 0;
	order: 2; // 历史栏放到聊天区右侧
	border-left: 1px solid var(--border-color);
	background-color: #fff;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;

	.panel-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px 14px;
		border-bottom: 1px solid var(--border-color);

		.panel-title {
			font-size: 14px;
			font-weight: 500;
			color: #222;
		}
	}

	.lunci-list {
		flex: 1;
		overflow-y: auto;
		padding: 8px;

		.lunci-item {
			padding: 8px 10px;
			margin-bottom: 6px;
			border-radius: 8px;
			background: #fafbfc;
			cursor: pointer;
			transition: background 0.15s;

			&:hover {
				background: #f0f2ff;
			}

			&.active {
				background: #f0f2ff;

				.lunci-title {
					color: #4958ec;
					font-weight: 500;
				}
			}

			.lunci-row {
				display: flex;
				align-items: center;
				gap: 4px;

				.top-flag {
					color: #f56c6c;
					font-size: 12px;
				}

				.lunci-title {
					flex: 1;
					font-size: 13px;
					color: #333;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}

			.lunci-meta {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 4px;

				.lunci-time {
					font-size: 12px;
					color: #999;
				}

				.lunci-ops {
					display: flex;
					gap: 8px;

					i {
						font-size: 13px;
						color: #999;
						cursor: pointer;

						&:hover {
							color: #4958ec;
						}
					}
				}
			}
		}

		.lunci-empty {
			text-align: center;
			color: #999;
			font-size: 12px;
			padding: 20px 10px;
		}
	}
}

.layout-chat-main {
	flex: 1;
	height: 100%;
	min-width: 0;
	order: 1; // 聊天区在左，历史栏在右

	display: flex;
	flex-direction: column;

	.chat-header {
		border-bottom: 1px solid var(--border-color);
		padding: 14px 20px;
	}

	.chat-input {
		border-top: 1px solid var(--border-color);
		padding: 10px 20px;

		.chat-input-box {
			border-radius: 10px;
			border: 1px solid #e1e2e5;
			position: relative;
			display: flex;
			align-items: center;
			padding-right: 10px;

			.input-box {
				::v-deep .el-textarea__inner {
					border: none;
					border-radius: 10px;
					font-size: 12px;
				}

				flex: 1;
			}

			.send-icon {
				cursor: pointer;

				.icon {
					width: 34px;
					height: 34px;
					display: block;
				}
			}
		}
	}

	.chat-box {
		flex: 1 1;
		overflow: auto;
		padding: 10px 0;
	}

	.opt-panel {
		margin-bottom: 10px;
		display: flex;

		.clean-chat-btn {
			border-radius: 8px;
			border: 1px solid #dee0e4;
			font-size: 12px;
			color: #737b8d;
			cursor: pointer;
			padding: 6px 10px;
			overflow: hidden;
			/* 确保超出容器的文本被隐藏 */
			white-space: nowrap;
			/* 防止文本换行 */
			text-overflow: ellipsis;

			&:hover {
				border-color: #f6f7f9;
				background: #f6f7f9;
			}
		}
	}
}

// —— 上传按钮 + 待发送附件预览 ——
.upload-btn {
	display: flex;
	align-items: center;
	gap: 3px;
	border-radius: 8px;
	border: 1px solid #dee0e4;
	font-size: 12px;
	color: #737b8d;
	cursor: pointer;
	padding: 6px 10px;

	&:hover {
		border-color: #f6f7f9;
		background: #f6f7f9;
	}

	i {
		font-size: 14px;
	}
}

.attachments {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 8px;
}

.attachment-img {
	position: relative;
	width: 56px;
	height: 56px;

	.img-thumb {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 6px;
	}

	.up-loading {
		position: absolute;
		inset: 0;
		margin: auto;
		color: #fff;
	}

	.remove-btn {
		position: absolute;
		top: -6px;
		right: -6px;
		color: #909399;
		background: #fff;
		border-radius: 50%;
		cursor: pointer;
	}
}

.attachment-file {
	display: flex;
	align-items: center;
	gap: 4px;
	background: #f1f2f5;
	border-radius: 6px;
	padding: 6px 8px;
	font-size: 12px;
	max-width: 200px;

	.file-name {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.remove-btn {
		color: #909399;
		cursor: pointer;
	}
}
</style>
